import React from 'react';
import { Icon } from 'antd';
import { Container } from './styles';

const Loader = ({ folder, fullpage, text, customStyle = {} }) => {

  const ComponentForText = () => (
    <div className='loaderContainer'>
      <div className="loaderText">{text}</div>
      <div className="spinner">
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
      </div>
    </div>
  )

  return (
    <Container folder={folder} fullpage={fullpage} style={customStyle}>
      {text ? <ComponentForText /> : <Icon type="loading" />}
    </Container>
  );
}

export default Loader;
